import { Box } from "@mui/material";
import { ReactNode } from "react";
import { INDIGO } from "@/config/mui/colorPalette";

export default function PaymentPlansBannerWrapper({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <Box
      sx={{
        p: 1.5,
        width: "100%",
        textAlign: "center",
        backgroundColor: INDIGO[20],
      }}
    >
      {children}
    </Box>
  );
}
